import React from "react";
import { useAppContext } from "../../hooks/useAppContext";

// Source: https://github.com/welldone-software/why-did-you-render

/**
 * This component will add information to the console
 * when '&whyRerender' is passed to the querystring.
 * It will show infomration why a component did rerender.
 *
 * Remark:
 * - Disable for production? size?
 * - Could we lazy load the 'whyDidYouRender' so we only load module when querystring is passed. (also production)
 */

export function WhyDidYouRerender() {
	const appContext = useAppContext();

	// only include package in dev build
	if (process.env.NODE_ENV === "development") {
		// Can't we solve this without the node 'require' syntax?
		// eslint-disable-next-line @typescript-eslint/no-require-imports
		const whyDidYouRender = require("@welldone-software/why-did-you-render");

		// Extract querystring from context
		const {
			platform: { queryString },
		} = appContext;

		const whyRerenderComponent = queryString.getQueryStringParameter("whyRerender");

		if (
			whyRerenderComponent !== undefined &&
			whyRerenderComponent !== "0" &&
			whyRerenderComponent !== "false"
		) {
			const config =
				whyRerenderComponent && whyRerenderComponent !== "true"
					? {
							include: whyRerenderComponent
								.split(",")
								.map((compName) => new RegExp(`\\b${compName}\\b`, "g")),
					  }
					: {
							// Everything wrapped with memo
							trackAllPureComponents: true,

							// Components with suffix Container
							include: [/.*Container/],
					  };
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			whyDidYouRender(React, config);
		}
	}

	return null;
}
